export default __webpack_public_path__ + "static/media/ketoenergybar-wide@2x.ae5f7c7b.jpg";